import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { SessionService } from '../auth/session/session.service';

@Injectable({
  providedIn: 'root',
})
export class PermissionGuard {
  constructor(
    private sessionService: SessionService,
    private router: Router,
  ) {}

  canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree {
    const requiredPermissions = route.data['permissions'] as string[];

    if (!requiredPermissions || requiredPermissions.length === 0) {
      return true;
    }

    const groups = this.sessionService.getCurrentSession()?.groups;
    const hasRequiredPermission = requiredPermissions.some(permission =>
      groups?.includes(permission)
    );

    if (hasRequiredPermission) {
      return true;
    }

    // Redirect to the default settings page (hierarchy) if user lacks permission
    return this.router.parseUrl('/settings/hierarchy/0/current');
  }
}
